import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { LotteryDrawn } from '../../models/lottery-draw.model';
import { FormGroup, UntypedFormControl } from '@angular/forms';
import { from, Observable } from 'rxjs';
import { DatabaseService } from '../../../../core/_services/database.service';
import { LotteryService } from '../../../../core/_services/lottery.service';
import { startWith, map } from 'rxjs/operators';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { Filter, LotteryFilterParam } from '../../models/filter.model';
import { Lottery } from '../../lottoloca-commom/lottery-modex';
import { LotteryDrawTask } from '../../models/task-queue.model';
import { LotteryTaskStatuses } from '../../models/task.model';
import { WhereFilterOp } from '../../../../core/_services/database-cast/IDatabase';
import { ControllersService } from '../../../../core/_services/controllers/controllers.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import * as am5exporting from "@amcharts/amcharts5/plugins/exporting";

@Component({
  selector: 'kt-filter-statistics',
  templateUrl: './filter-statistics.component.html',
  styleUrls: ['./filter-statistics.component.scss']
})
export class FilterStatisticsComponent implements OnInit, OnDestroy, OnChanges {

  subscribleChart: () => void;

  @Input() selectedFilterId: any;
  @Input() betId: any;
  @Output() public savedParams: EventEmitter<LotteryFilterParam> = new EventEmitter();

  @Input() public preSelected = false;

  _chartRoot: am5.Root;
  _chart: am5xy.XYChart;
  _pieRoot: am5.Root;
  _chartTotal: am5percent.PieChart;


  _description: string;
  _progress: number = 0;
  _showGraph: boolean = true;
  _opacity = "normal-opacity";

  _filter: Filter;
  _filterName: string = "Carregando...";
  _filterListx: Filter[];
  _lottery: Lottery;
  _min: number = 0;
  _max: number = 100000;
  _chartData: { Key: string; Count: any; Min: any; Max: any; }[] = [];
  _initialized: any;
  _rangeOptionsControl = new UntypedFormControl();
  _rangeOptions: { id: number; name: string; }[];

  _graphHeight: string = "0px";
  _lotteryDrawn: LotteryDrawn;

  _startLotteryDrawControl = new UntypedFormControl();
  _endLotteryDrawControl = new UntypedFormControl();

  _selectedFilterForm = new FormGroup({
    selectedId: new UntypedFormControl('')
  });

  _options: string[] = ['One', 'Two', 'Three'];

  _startfilteredOptions: Observable<string[]>;
  _endfilteredOptions: Observable<string[]>;
  _endLotteryDrawLabel: string;
  _startLotteryDrawLabel: string;
  _updateChartLabel: string;
  _sort: string = "alphabetic";
  searchLotteryFilters: (text: string) => Observable<any[]>;
  displayLotteryName: (lottery: any) => string;
  getLotteryFilterById: (id: number) => Promise<any>;

  constructor(
    private _database: DatabaseService,
    private _controllersService: ControllersService,
    private _lotteryService: LotteryService
  ) {

    this._rangeOptionsControl.setValue("1");
    this._startfilteredOptions = this._startLotteryDrawControl.valueChanges
      .pipe(startWith(''), map(value => this.filterSelectOption(value)));
    this._endfilteredOptions = this._endLotteryDrawControl.valueChanges
      .pipe(startWith(''), map(value => this.filterSelectOption(value)));
    this._rangeOptionsControl.valueChanges.subscribe(() => this.onRefreshClick());

    this._startLotteryDrawLabel = "Concurso inicial";
    this._endLotteryDrawLabel = "Concurso final";
    this._updateChartLabel = "Atualizar Gráfico";


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedFilterId != null) {
      this._progress = 0;
      // this._selectedFilterIdControl.setValue(this.selectedFilterId);
    }
    this.reloadChartData();
  }

  onFiltroSelecionado(id: number | null) {

    this.selectedFilterId = id;
    this.reloadChartData();
  }

  private filterSelectOption(value: string): string[] {
    const filterValue = (value || '').toString().toLowerCase();
    let filtered = this._options.filter(option => option.toLowerCase().includes(filterValue));
    return filtered.length > 100 ? filtered.slice(0, 100) : filtered;
  }

  ngOnInit() {
    this.loadLotteryData().then(() => {
      //arrumar
      // if (!this.selectedFilterId) {
      //   this.selectedFilterId = this._filterList[0].id;
      //   this._selectedFilterIdControl.setValue(this.selectedFilterId);
      // }
      this.reloadChartData();
      // this._selectedFilterForm.get('selectedId')!.valueChanges.subscribe(value => {
      //  debugger;
      //   if (typeof value !== 'string') {
      //     this.selectedFilterId = value?.id ?? null;
      //     this.reloadChartData();
      //   }
      // });
    });
  }

  ngOnDestroy(): void {
    if (this.subscribleChart) this.subscribleChart();
    if (this._chartRoot) this._chartRoot.dispose();
    if (this._pieRoot) this._pieRoot.dispose();
  }

  public loadLotteryData() {

    return new Promise<void>((resolve) => {
      this._lotteryService.getCurrentLotteryMode()
        .then(lottery => {
          this._lottery = lottery;

          this.searchLotteryFilters = (text: string): Observable<any[]> => {

            return from(this._lotteryService.searchLotteryFilters(text, lottery.id));
          };

          this.displayLotteryName = (lottery: any): string => {
            return lottery?.name || '';
          };
          this.getLotteryFilterById = (id: number): Promise<any> => {
            return this._lotteryService.getCurrentLotteryFilter(id, this._lottery.id);
          };

          this._database.getLotteryDraws().getLotteryDraw(lottery.id).getData()
            .then(lotteryDrawn => {
              if (lotteryDrawn) {
                this._lotteryDrawn = lotteryDrawn;
                this._options = this._lotteryDrawn.Ids.map(x => parseInt(x.toString()).toString());
                this._startLotteryDrawControl.setValue(parseInt(this._lotteryDrawn.Min));
                this._endLotteryDrawControl.setValue(parseInt(this._lotteryDrawn.Max));
              }
              //arrumar
              // this._lotteryService.getCurrentLotteryFilters().then(filters => {

              //   this._filterList = filters.filter(x => x.filterTypeId < 200);
              //   this._initialized = true;
              //   resolve();
              // });
              if (this.selectedFilterId != null) {
                this._initialized = true;

                resolve();

              }

              this._initialized = true;
            });
        });
    });
  }

  reloadChartData() {
    if (!this._initialized) return;
    this._lotteryService.getCurrentLotteryFilter(this.selectedFilterId, this._lottery.id).then(filter => {
      this._filter = filter;
      if (this._filter != null) {
        this._max = this._filter.maxDefault;
        this._min = this._filter.minDefault;
        this._filterName = this._filter.name;
      }

      setTimeout(() => this.refreshChart(), 0);
    });
  }



  refreshChart(): void {
    this._opacity = "low-opacity";

    const start = this._lotteryDrawn.Ids.find(x => parseInt(x) == parseInt(this._startLotteryDrawControl.value));
    let end = this._lotteryDrawn.Ids.find(x => parseInt(x) == parseInt(this._endLotteryDrawControl.value));
    end = (parseInt(end) - 1).toString();

    this._rangeOptions = this._lottery.awardParams.map(x => ({ id: x.index, name: x.description }));
    let index = this._rangeOptionsControl.value || "1";

    if (!start || !end || start >= end) {
      console.log("Erro de parametros");
      return;
    }


    if (this._filter == null) return;
    this.clearChart();
    if (this.subscribleChart) this.subscribleChart();

    const filterData = this._filter.data ? this._filter.data.toString().trim() : "";

    this.subscribleChart = this._database.getLotteryDraws()
      .getLotteryDraw(this._lottery.id)
      .getDocument().collection(`statistics/filter/${this._filter.filterTypeId}/${end}-${index}/reports`)
      .where("Data", "==", filterData)
      .onSnapshot(querySnapshot => {
        if (querySnapshot.docs.length == 0) {
          const task = new LotteryDrawTask();
          task.lotteryId = this._lottery.id;
          task.reportType = "filter";
          task.status = LotteryTaskStatuses.Waiting;
          task.data = { minId: start, maxId: end, filterTypeId: this._filter.filterTypeId, filterData, index };
          this._controllersService.getTasks().addLotteryDrawnTask(task).catch(console.log);
        } else {
          const snapshot = querySnapshot.docs[0];
          if (snapshot.data().Pages && snapshot.data().Pages > 0) {
            this._showGraph = true;
            let list = [];
            let operation: WhereFilterOp = snapshot.data().Pages <= 3 ? ">=" : this._sort == "desc" ? ">=" : "<=";
            let operationValue = snapshot.data().Pages <= 3 ? 1 : snapshot.data().Pages - 1;

            this._database.getLotteryDraws()
              .getLotteryDraw(this._lottery.id)
              .getDocument().collection(`statistics/filter/${this._filter.filterTypeId}/${end}-${index}/reports/${snapshot.id}/pages`)
              .where("Page", operation, operationValue)
              .get()
              .then(queryResult => {
                queryResult.docs.forEach(doc => list = [...list, ...doc.data().Items]);
                this._graphHeight = `${Math.max(list.length * 50, 500)}px`;
                this.drawChart(list);
              });
          } else {
            this._showGraph = false;
            this._progress = snapshot.data().Progress * 100;
          }
        }
      });
  }

  clearChart(): void {
    if (this._chartRoot) this._chartRoot.dispose();
    this._chartRoot = am5.Root.new("chartdiv");
    this._chartRoot.setThemes([am5themes_Animated.new(this._chartRoot)]);
    this._chart = this._chartRoot.container.children.push(am5xy.XYChart.new(this._chartRoot, {}));

    if (this._pieRoot) this._pieRoot.dispose();
    this._pieRoot = am5.Root.new("charttotaldiv");
    this._pieRoot.setThemes([am5themes_Animated.new(this._pieRoot)]);
    this._chartTotal = this._pieRoot.container.children.push(am5percent.PieChart.new(this._pieRoot, {}));
  }

  drawChart(numbers: any[]): void {
    this._chart.xAxes.clear();
    this._chart.yAxes.clear();
    this._chart.series.clear();

    this._opacity = "normal-opacity";

    const data = numbers.map(item => {
      const split = item.Key.split(' ');
      //  const key = split[0];

      const key = item.Key;
      return { Key: key, Count: item.Contest, Min: split[0], Max: split[1] };
    });

    if (this._sort == "asc") data.sort((a, b) => a.Count - b.Count);
    else if (this._sort == "desc") data.sort((a, b) => b.Count - a.Count);
    else data.sort((a, b) => parseInt(a.Key) - parseInt(b.Key));

    this._chartData = data;
    this.redrawChart();
  }


  redrawChart() {
    this.drawBarChart();
    this.drawPieChart();
  }

  private drawBarChart() {
    this._chart.xAxes.clear();
    this._chart.yAxes.clear();
    this._chart.series.clear();

    const xAxis = this._chart.xAxes.push(am5xy.ValueAxis.new(this._chartRoot, {
      renderer: am5xy.AxisRendererX.new(this._chartRoot, {})
    }));

    const yAxis = this._chart.yAxes.push(am5xy.CategoryAxis.new(this._chartRoot, {
      categoryField: "Key",
      renderer: am5xy.AxisRendererY.new(this._chartRoot, {
        inversed: true
      })
    }));

    yAxis.data.setAll(this._chartData);

    const series = this._chart.series.push(am5xy.ColumnSeries.new(this._chartRoot, {
      name: "Intersecção do filtro",
      xAxis,
      yAxis,
      valueXField: "Count",
      categoryYField: "Key"
    }));

    series.columns.template.adapters.add("fill", (fill, target) => {
      const data = target.dataItem?.dataContext as { Key: string; Count: number };
      if (!data) return fill;

      const split = data.Key.split(' ');
      if (split.length == 1) {
        const keyAsNumber = parseInt(data.Key);
        if (keyAsNumber < this._min) return am5.color(0xb51e1e);
        if (keyAsNumber > this._max) return am5.color(0xf3a128);
      }
      else {
        const minAsNumber = parseInt(split[0]);
        const maxAsNumber = parseInt(split[2]);
        if (minAsNumber < this._min) return am5.color(0xb51e1e);
        if (maxAsNumber > this._max) return am5.color(0xf3a128);
      }
      return fill;
    });

    series.data.setAll(this._chartData);

    const max = Math.max(...this._chartData.map(x => x.Count));
    const min = Math.min(...this._chartData.map(x => x.Count));
    const medium = (max + min) / 2;

    series.bullets.push((root, series, dataItem) => {
      const value = dataItem.get("valueX");
      const color = value >= medium ? am5.color("#ffffff") : am5.color("#444444");
      const deslocamento = value >= medium ? -50 : 5;

      return am5.Bullet.new(root, {
        locationX: 1,
        sprite: am5.Label.new(root, {
          text: "{valueX}",
          fill: color,
          centerY: am5.p50,
          centerX: am5.p0,
          dx: deslocamento,
          populateText: true
        })
      });
    });

       const exporting = am5exporting.Exporting.new(this._chartRoot, {
          menu: am5exporting.ExportingMenu.new(this._chartRoot, {}),
          dataSource: {
            data: this._chartData.map(d => ({ numero: d.Key, frequencia: d.Count })),
            fields: ["numero", "frequencia"]  // <-- Obrigatório para CSV aparecer
          },
          filePrefix: "frequencia_" + new Date().toISOString().substring(0, 10)
        });
    
  }

  private drawPieChart() {
    this._chartTotal.series.clear();

    const totalData = [
      { Status: -1, Key: "Abaixo", Count: 0 },
      { Status: 0, Key: "Aprovado", Count: 0 },
      { Status: 1, Key: "Acima", Count: 0 }
    ];

    this._chartData.forEach(value => {
      const keyVal = parseInt(value.Key);
      if (keyVal < this._min) totalData[0].Count += value.Count;
      else if (keyVal > this._max) totalData[2].Count += value.Count;
      else totalData[1].Count += value.Count;
    });

    const pieSeries = this._chartTotal.series.push(am5percent.PieSeries.new(this._pieRoot, {
      valueField: "Count",
      categoryField: "Key"
    }));

    pieSeries.slices.template.adapters.add("fill", (fill, target) => {
      const data = target.dataItem?.dataContext as { Status: number };
      if (!data) return fill;

      switch (data.Status) {
        case -1: return am5.color(0xb51e1e);
        case 0: return am5.color(0x28a745);
        case 1: return am5.color(0xf3a128);
        default: return fill;
      }
    });

    pieSeries.data.setAll(totalData.filter(x => x.Count > 0));

 

  }


  exportToExcel() {
    const series = this._chart.series.getIndex(0);
    const data = series.dataItems.map(item => {
      const ctx = item.dataContext as any;
      return {
        Valor: ctx.Key,
        Ocorrencias: ctx.Count
      };
    });
  
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = { Sheets: { 'Valor': worksheet }, SheetNames: ['Valor'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, 'Filtro_'+this._filterName+'_'+ new Date().toISOString().substring(0, 10)+'.xlsx');
  }

  onRefreshClick(): void {
    this.refreshChart();
  }

  changeSort(event) {
    this.refreshChart();
  }

  changeFilterValues(filterParam: LotteryFilterParam) {
    this._min = filterParam.minLimit;
    this._max = filterParam.maxLimit;
    this.redrawChart();
  }
}
